
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Workorder,
  WorkordersApi,
  ValidationProblemDetails
} from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    ordersApi: 'ordersApi'
  })
})
export default class TransferOrderComponent extends Vue {
  private currentUser!: User;

  private ordersApi!: WorkordersApi;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  reason = '';
  newAssignee = '';
  targetPropertyId = '';
  targetBuilding = '';
  targetJobType = '';

  // https://stackoverflow.com/a/43531779/86860
  isMounted = false;

  private validationProblems: ValidationProblemDetails = {};

  get currentOrderPropertyId() {
    return this.order.propertyId;
  }
  get currentOrderBuilding(): string {
    return this.order.building || '';
  }
  get newPropBuildingOk() {
    if (!this.isMounted) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const picker = this.$refs.buildingPicker as any;
    if (!picker) return false;
    return picker.buildingListContains(this.currentOrderBuilding);
  }

  get currentOrderJobType() {
    return this.order.jobType;
  }
  get newPropJobTypeOk() {
    if (!this.isMounted) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const picker = this.$refs.jobTypePicker as any;
    if (!picker) return false;
    return picker.jobTypeListContains(this.currentOrderJobType);
  }

  get readyToTransfer() {
    return (
      (this.newPropBuildingOk || this.targetBuilding !== '') &&
      (this.newPropJobTypeOk || this.targetJobType !== '') &&
      this.targetPropertyId !== this.order.propertyId
    );
  }

  get canTransfer() {
    if (this.order.orderCategory === 'PM') {
      return false;
    }
    let canTransfer = false;
    this.currentUser.profile.candoq.forEach((candoq: string) => {
      if (candoq.startsWith('Reassign Orders:') && !candoq.endsWith(' None')) {
        canTransfer = true;
      }
    });
    return canTransfer;
  }

  data() {
    return {
      targetPropertyId: undefined,
      targetBuilding: undefined,
      targetJobType: undefined
    };
  }

  async mounted() {
    // https://stackoverflow.com/a/43531779/86860
    this.isMounted = true;
  }

  private successHandler(order: Workorder) {
    if (order && order.workorderId) {
      this.$emit('transferred');
      this.popoverOpen = false;
      this.targetJobType = '';
      this.targetPropertyId = '';
      this.targetBuilding = '';
      this.validationProblems = {};
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      const el = document.getElementById('error-display');
      if (el) {
        el.scrollIntoView(true);
      }
    }, 100);
  }

  private transfer() {
    this.ordersApi
      .transferTo({
        workorderEntityTransferCommand: {
          workorderId: this.order.workorderId,
          targetPropertyId: this.targetPropertyId,
          targetJobType: this.targetJobType || this.order.jobType,
          targetLocation1: this.targetBuilding || this.order.building
        }
      })
      .then(this.successHandler, this.errorHandler);
  }

  private async cancelTransfer() {
    this.popoverOpen = false;
    this.validationProblems = {};
    this.targetJobType = '';
    this.targetPropertyId = '';
    this.targetBuilding = '';
  }

  popoverOpen = false;
}
